import React from "react";

import { Tariff } from "features/Tariff";
import { PageTitle } from "shared/ui";

const TariffPage = () => {
    return (
        <>
            <PageTitle>Тариф</PageTitle>
            <Tariff />
        </>
    );
};

export default TariffPage;
